export enum ColumnCoords {
  ActivityGroup = 0,
  Activity = 1,
  Location = 2,
  StartColumn = 3,
  FinishColumn = 4,
  CommentColumn = 5,
}
